/* State type for articles in the catalogue */
export enum ArticleState {
	OK = 0,
	Warning = 1,
	Error = 2,
	New = 4,
	Info = 6,
	Deleted = 9,
}
